import AdManagementReducer from 'store/ad-management/reducers';

export default AdManagementReducer;
